import React, { useEffect } from 'react';
import * as echarts from 'echarts';
import { Card } from '@mui/material';
import { CardContent } from 'semantic-ui-react';

const Chart = () => {
  useEffect(() => {
    // Data for the pie chart
    const pieChartData = [
      { value: 335, name: 'Category A' },
      { value: 310, name: 'Category B' },
      { value: 234, name: 'Category C' },
      { value: 135, name: 'Category D' },
      { value: 1548, name: 'Category E' },
    ];

    // Data for the bar chart
    const barChartData = {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],
      series: [
        { name: 'Series A', data: [150, 200, 220, 180, 210] },
        { name: 'Series B', data: [80, 90, 110, 100, 120] },
      ],
    };

    // Initialize pie chart
    const pieChart = echarts.init(document.getElementById('pie-chart'));
    const pieChartOptions = {
      title: {
        text: 'Pie Chart Example',
        left: 'center',
      },
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)',
      },
      legend: {
        orient: 'vertical',
        left: 'left',
        data: pieChartData.map((item) => item.name),
      },
      series: [
        {
          name: 'Pie Chart',
          type: 'pie',
          radius: '55%',
          center: ['50%', '60%'],
          data: pieChartData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    };
    pieChart.setOption(pieChartOptions);

    // Initialize bar chart
    const barChart = echarts.init(document.getElementById('bar-chart'));
    const barChartOptions = {
      title: {
        text: 'Bar Chart Example',
        left: 'center',
        top: 10, // Adjust the top position to avoid collision with legend
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      legend: {
        data: barChartData.series.map((item) => item.name),
        top: 40, // Adjust the top position to avoid collision with title
      },
      xAxis: {
        data: barChartData.categories,
        axisLabel: {
          interval: 0,
          rotate: 30,
        },
      },
      yAxis: {
        type: 'value',
      },
      series: barChartData.series.map((item) => ({
        name: item.name,
        type: 'bar',
        data: item.data,
      })),
    };
    barChart.setOption(barChartOptions);

    // Clean up the charts when the component unmounts
    return () => {
      pieChart.dispose();
      barChart.dispose();
    };
  }, []); // Empty dependency array ensures that this effect runs only once

  return (
    <Card>
        <CardContent>
            <div id="pie-chart" style={{ width: '50%', height: '400px', float: 'left' }} />
            <div id="bar-chart" style={{ width: '50%', height: '400px', float: 'left' }} />
        </CardContent>
    </Card>
  );
};

export default Chart;
